// extracted by mini-css-extract-plugin
export default {"mobileFilters":"sprints_mobileFilters__o9XjB","desktopFilters":"sprints_desktopFilters__V-XdE"};